export { Impact } from './impact.page';
